import script from "./WeddingContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeddingContent.vue?vue&type=script&setup=true&lang=ts"

import "./WeddingContent.vue?vue&type=style&index=0&id=465fbd5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465fbd5e"]])

export default __exports__